import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import React, { useMemo } from 'react';
import { useFetchOrganizer } from '../hooks/use-fetch-organizer';
import { useOrganizer } from '../hooks/use-organizer';

type OrganizerContainerProps = {
  children: (isLoading: boolean, info: Organizer | null) => JSX.Element;
};

/**
 * Custom comparison function for React.memo
 * Only re-render if the children function reference has changed
 */
const propsAreEqual = (prevProps: OrganizerContainerProps, nextProps: OrganizerContainerProps): boolean => {
  // Only re-render if the children function reference has changed
  return prevProps.children === nextProps.children;
};

const OrganizerContainer = React.memo((props: OrganizerContainerProps) => {
  useFetchOrganizer();
  const { isLoading, info } = useOrganizer();

  // Memoize the result of the children function to prevent unnecessary re-renders
  const renderedChildren = useMemo(() => {
    return props.children(isLoading, info);
  }, [props.children, isLoading, info]);

  return renderedChildren;
}, propsAreEqual);

export default OrganizerContainer;
